import { AverageWindow } from './AverageWindow';

export type ItemTypeKey = string | number;

export class MultiTypeAverageWindow {
  private readonly windows = new Map<ItemTypeKey, AverageWindow>();

  constructor(
    private readonly capacity: number,
    private readonly fallback: number,
  ) {}

  getCurrentValue(type: ItemTypeKey): number {
    const window = this.windows.get(type);
    return window ? window.currentValue : this.fallback;
  }

  addValue(value: number, type: ItemTypeKey): void {
    let window = this.windows.get(type);
    if (!window) {
      window = new AverageWindow(this.capacity, this.fallback);
      this.windows.set(type, window);
    }
    window.addValue(value);
  }
}
